'use client';

import { useState } from 'react';

import { Button } from '@extern/ui/button';
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaHeaderIcon,
  CredenzaTitle,
} from '@extern/ui/credenza';
import { CheckIcon } from '@phosphor-icons/react';
import { useSearchParams } from 'next/navigation';

export function SuccessModal() {
  const params = useSearchParams();
  const isSuccess = params.get('success');
  const [open, setOpen] = useState(isSuccess !== null);

  return (
    <Credenza onOpenChange={setOpen} open={open}>
      <CredenzaContent className="gap-6 px-6 pb-6 md:p-8">
        <CredenzaHeader>
          <CredenzaHeaderIcon className="flex size-12 items-center justify-center rounded-full bg-role-success-container text-role-on-success-container">
            <CheckIcon className="size-6" />
          </CredenzaHeaderIcon>
          <CredenzaTitle>Your gift has been sent</CredenzaTitle>
        </CredenzaHeader>
        <CredenzaBody>
          <CredenzaDescription>Your gift is headed to their inbox with simple redeem steps.</CredenzaDescription>
        </CredenzaBody>
        <CredenzaFooter>
          <CredenzaClose asChild>
            <Button>Close</Button>
          </CredenzaClose>
        </CredenzaFooter>
      </CredenzaContent>
    </Credenza>
  );
}
